export function EmptyState({ message }: { message: string }) {
  return <div className="h-72 flex items-center justify-center text-sm text-muted-foreground">{message}</div>;
}
